import { type BundleMachineGuard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether the bundle has at least one product in it.
 */
export const checkIfHasSelectedProducts: BundleMachineGuard = (guardArgs) => {
  const { context } = guardArgs;

  return context.selectedProducts.length > 0;
};
